import React from "react";
import { Layout, Row, Col } from "antd";
import { NavLink } from "react-router-dom";
import { Content } from "../";

const Header = () => {
  return (
    <Layout.Header style={{ backgroundColor: "#fff" }}>
      <Content>
        <Row gutter={16}>
          <Col md={8} style={{ textAlign: "left" }}>
            <div style={{ maxHeight: "54px", width: "100%" }}>
              <img
                style={{ padding: "8px", width: "175px" }}
                src="/images/pdview-logo.svg"
                alt="logo"
              />
            </div>
          </Col>
          <Col md={16} style={{ textAlign: "right", paddingRight: "24px" }}>
            <NavLink to={"/logout"}>Logout</NavLink>
          </Col>
        </Row>
      </Content>
    </Layout.Header>
  );
};

export default Header;



// WEBPACK FOOTER //
// ./src/components/header/Header.jsx